<template>
    <el-main class="bg-info-light">
        <div class="bg-light padding-20">
            <div class="text-right">
                <slot name="right-btn"></slot>
            </div>
            <slot></slot>
        </div>
    </el-main>
</template>

<script>
export default {
    name: "MainLayout",
    data() {
        return {
            breadText: []
        }
    },
    methods: {
        bread() {
            this.breadText = [];
            for (let i = 0; i < this.$route.meta.length; i++) {
                this.breadText.push(this.$route.meta[i]);
            }
        }
    },
    mounted() {
        this.breadText = [];
        let _path = this.$route.path.split("/");

        if (_path[1] === 'bids' || _path[1] === 'news') {
            let _t1 = '';
            if (_path[1] === 'bids') {
                switch (_path[2]) {
                    case 'odd': {
                        _t1 = '散单平台';
                        break;
                    }
                    case 'notice': {
                        _t1 = '招标公告';
                        break;
                    }
                    case 'coldChain': {
                        _t1 = '冷链专区';
                        break;
                    }
                    case 'storage': {
                        _t1 = '仓储供求';
                        break;
                    }
                    case 'device': {
                        _t1 = '设备采购';
                        break;
                    }
                }
            } else if (_path[1] === 'news') {
                switch (_path[2]) {
                    case 'policy': {
                        _t1 = '政策法规';
                        break;
                    }
                    case 'logistics': {
                        _t1 = '物流资讯';
                        break;
                    }
                }
            }

            let _t2 = '';
            switch (_path[3]) {
                case 'list': {

                    break;
                }
                case 'add': {
                    _t2 = '添加';
                    break;
                }
                case 'edit': {
                    _t2 = '编辑';
                    break;
                }
                // case ''
            }

            this.breadText.push(_t2 + _t1);
        } else {
            for (let i = 0; i < this.$route.meta.length; i++) {
                this.breadText.push(this.$route.meta[i]);
            }
        }
    }
}
</script>
